import React from 'react';
import BoxRowBase from './BoxRow';

function BoxRow(props) {
  return <BoxRowBase {...props} />;
}

export default BoxRow;
